export function formatDate(dateString: string) {
  const date = new Date(dateString);
  return {
    day: date.getDate(),
    month: date.toLocaleString("pt-BR", { month: "long" }),
    year: date.getFullYear(),
  };
}
export function formatDateFull(date: string, locale: string = 'pt-BR') {
  const d = new Date(date);
  const cleanDate = new Date(d.getFullYear(), d.getMonth(), d.getDate());

  return cleanDate.toLocaleDateString(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
}

export function formatDateFullWithHours(date: string, locale: string = 'pt-BR') {
  return new Date(date).toLocaleString(locale, { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function formatDateTime(date: string, locale: string = 'pt-BR') {
  if (locale !== 'pt-BR') return new Date(date).toLocaleString(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',

    timeZone: 'UTC',
    hour12: false
  });

  return new Date(date).toLocaleString(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone: 'UTC',
    hour12: false
  });
}
